import React, { useState, useEffect } from 'react';
import API from '../api/api';

function Slots({ partnership }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState('');
  const [expandedSlot, setExpandedSlot] = useState(null);
  const [newIssueSlot, setNewIssueSlot] = useState(null);
  const [newIssueForm, setNewIssueForm] = useState({from_date:'', name:'', slot_partners:[{partner_id:'', share:1}]});
  const [editingIssue, setEditingIssue] = useState(null);
  const [dragOver, setDragOver] = useState(null);
  const [dragSlot, setDragSlot] = useState(null);

  useEffect(() => { load(); }, [partnership.id]);

  const load = async () => {
    setLoading(true);
    const res = await API.get(`/slots/${partnership.id}/`);
    setData(res.data);
    setLoading(false);
  };

  const save = async (action, payload) => {
    try {
      await API.post(`/slots/${partnership.id}/`, { action, ...payload });
      setMsg('تم الحفظ');
      setTimeout(() => setMsg(''), 2000);
      await load();
    } catch(e) { setMsg('خطا'); }
  };

  const partners = data?.partners || [];
  const slots = data?.slots || [];

  if (loading) return <div style={{textAlign:'center',padding:'30px'}}>جاري التحميل...</div>;

  return (
    <div style={{padding:'15px'}} dir="rtl">
      {editingIssue && (
        <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center'}}>
          <div style={{background:'white',padding:'24px',borderRadius:'12px',minWidth:'600px',maxWidth:'90vw',direction:'rtl',maxHeight:'80vh',overflowY:'auto'}}>
            <h4 style={{margin:'0 0 16px',color:'#1e3a5f'}}>✏️ تعديل الإصدار</h4>
            <div style={{marginBottom:'12px'}}>
              <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>من تاريخ</label>
              <input type="date" value={editingIssue.from_date||''} onChange={e=>setEditingIssue({...editingIssue,from_date:e.target.value})}
                style={{width:'100%',padding:'7px',border:'1px solid #ddd',borderRadius:'5px',boxSizing:'border-box'}}/>
            </div>
            <div style={{marginBottom:'12px'}}>
              <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'8px'}}>الشركاء والأنصبة</label>
              {editingIssue.slot_partners?.map((sp,si)=>(
                <div key={si} style={{display:'flex',gap:'8px',marginBottom:'8px',alignItems:'center'}}>
                  <select value={sp.partner_id||sp.partner||''} onChange={e=>{
                    const sps=[...editingIssue.slot_partners];
                    sps[si]={...sps[si],partner_id:parseInt(e.target.value)};
                    setEditingIssue({...editingIssue,slot_partners:sps});
                  }} style={{flex:2,padding:'6px',border:'1px solid #ddd',borderRadius:'4px',fontSize:'12px'}}>
                    <option value=''>اختر شريك</option>
                    {partners.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
                  </select>
                  <input type="number" step="0.5" value={sp.share||1} onChange={e=>{
                    const sps=[...editingIssue.slot_partners];
                    sps[si]={...sps[si],share:parseFloat(e.target.value)};
                    setEditingIssue({...editingIssue,slot_partners:sps});
                  }} style={{width:'200px',padding:'6px',border:'1px solid #ddd',borderRadius:'4px',fontSize:'13px'}} placeholder="النصيب"/>
                  <div style={{display:'flex',flexDirection:'column',gap:'2px'}}>
                    {si>0 && <button onClick={()=>{
                      const sps=[...editingIssue.slot_partners];
                      [sps[si-1],sps[si]]=[sps[si],sps[si-1]];
                      setEditingIssue({...editingIssue,slot_partners:sps});
                    }} style={{padding:'2px 6px',background:'#7f8c8d',color:'white',border:'none',borderRadius:'3px',cursor:'pointer',fontSize:'10px'}}>↑</button>}
                    {si<editingIssue.slot_partners.length-1 && <button onClick={()=>{
                      const sps=[...editingIssue.slot_partners];
                      [sps[si],sps[si+1]]=[sps[si+1],sps[si]];
                      setEditingIssue({...editingIssue,slot_partners:sps});
                    }} style={{padding:'2px 6px',background:'#7f8c8d',color:'white',border:'none',borderRadius:'3px',cursor:'pointer',fontSize:'10px'}}>↓</button>}
                  </div>
                  {si>0 && <button onClick={()=>{
                    const sps=editingIssue.slot_partners.filter((_,i)=>i!==si);
                    setEditingIssue({...editingIssue,slot_partners:sps});
                  }} style={{padding:'4px 8px',background:'#e74c3c',color:'white',border:'none',borderRadius:'4px',cursor:'pointer'}}>✕</button>}
                </div>
              ))}
              <button onClick={()=>setEditingIssue({...editingIssue,slot_partners:[...editingIssue.slot_partners,{partner_id:'',share:1}]})}
                style={{padding:'5px 12px',background:'#3498db',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',fontSize:'12px'}}>+ شريك آخر</button>
            </div>
            <div style={{display:'flex',gap:'8px',justifyContent:'flex-end',marginTop:'16px'}}>
              <button onClick={async()=>{
                await save('update_issue',{issue_id:editingIssue.id,from_date:editingIssue.from_date,slot_partners:editingIssue.slot_partners});
                setEditingIssue(null);
              }} style={{padding:'8px 20px',background:'#27ae60',color:'white',border:'none',borderRadius:'5px',cursor:'pointer',fontWeight:'bold'}}>حفظ</button>
              <button onClick={()=>setEditingIssue(null)}
                style={{padding:'8px 20px',background:'#e74c3c',color:'white',border:'none',borderRadius:'5px',cursor:'pointer'}}>إلغاء</button>
            </div>
          </div>
        </div>
      )}
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'15px'}}>
        <h4 style={{margin:0,color:'#1e3a5f'}}>الخانات والإصدارات</h4>
        <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
          {msg && <span style={{padding:'5px 10px',background:'#d4edda',borderRadius:'5px',fontSize:'12px'}}>{msg}</span>}
          <button onClick={()=>save('add_slot',{partner_id:''})}
            style={{padding:'7px 14px',background:'#1e3a5f',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'12px'}}>
            + إضافة خانة
          </button>
        </div>
      </div>

      <p style={{fontSize:'11px',color:'#888',background:'#fff3cd',padding:'8px',borderRadius:'6px',margin:'0 0 15px'}}>
        كل إصدار يبدأ من تاريخ محدد ولا يؤثر على الفترات السابقة. النصيب = الوزن النسبي لتوزيع رسوم العداد والعامل.
      </p>

      {slots.map((slot,si) => (
        <div key={slot.id}
          draggable
          onDragStart={()=>setDragSlot(slot.id)}
          onDragOver={e=>{e.preventDefault();setDragOver(slot.id);}}
          onDragLeave={()=>setDragOver(null)}
          onDrop={async()=>{
            if(dragSlot && dragSlot!==slot.id){
              await save('reorder_slots',{slot_id:dragSlot, target_id:slot.id});
            }
            setDragSlot(null);setDragOver(null);
          }}
          style={{background:'white',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)',marginBottom:'12px',overflow:'hidden',
            border:dragOver===slot.id?'2px dashed #3498db':'2px solid transparent',cursor:'grab'}}>
          <div style={{display:'flex',alignItems:'center',gap:'10px',padding:'12px 15px',background:'#f0f4f8',cursor:'pointer'}}
            onClick={()=>setExpandedSlot(expandedSlot===slot.id?null:slot.id)}>
            <span style={{background:'#1e3a5f',color:'white',borderRadius:'50%',width:'28px',height:'28px',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'13px',fontWeight:'bold',flexShrink:0}}>{slot.order}</span>
            <div style={{flex:1}}>
              {slot.issues.map((issue,ii) => (
                <div key={issue.id} style={{fontSize:'12px',color: ii===slot.issues.length-1?'#1e3a5f':'#999'}}>
                  {ii===slot.issues.length-1?'الإصدار الحالي: ':''}
                  {issue.slot_partners.map(sp=>sp.partner_name+(sp.share!==1?' (نصيب '+sp.share+')':'')).join(' + ')}
                  {ii===slot.issues.length-1?'':' (من '+issue.from_date+')'}
                </div>
              ))}
            </div>
            <button onClick={e=>{e.stopPropagation();
              const lastIssue = slot.issues[slot.issues.length-1];
              if(lastIssue) setEditingIssue({...lastIssue, slot_partners: lastIssue.slot_partners.map(sp=>({...sp, partner_id: sp.partner_id||sp.partner}))});
            }} style={{padding:'4px 8px',background:'#e67e22',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',fontSize:'11px'}}>✏️ تعديل</button>
            <button onClick={e=>{e.stopPropagation();if(window.confirm('حذف هذه الخانة؟'))save('delete_slot',{slot_id:slot.id});}}
              style={{padding:'4px 8px',background:'#e74c3c',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',fontSize:'11px'}}>حذف</button>
            <span style={{color:'#999',fontSize:'12px'}}>{expandedSlot===slot.id?'▲':'▼'}</span>
          </div>

          {expandedSlot===slot.id && (
            <div style={{padding:'15px'}}>
              {slot.issues.map((issue,ii) => (
                <div key={issue.id} style={{background:ii===slot.issues.length-1?'#f0fff4':'#fafafa',border:'1px solid',borderColor:ii===slot.issues.length-1?'#27ae60':'#eee',borderRadius:'8px',padding:'12px',marginBottom:'10px'}}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'8px'}}>
                    <span style={{fontSize:'12px',fontWeight:'bold',color:ii===slot.issues.length-1?'#27ae60':'#999'}}>
                      {ii===slot.issues.length-1?'الإصدار الحالي':'إصدار سابق'} - من {issue.from_date}
                      {issue.name?' ('+issue.name+')':''}
                    </span>
                    <div style={{display:'flex',gap:'5px'}}>

                      <button onClick={()=>setEditingIssue({...issue, slot_id:slot.id})}
                        style={{padding:'3px 7px',background:'#e67e22',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',fontSize:'11px'}}>✏️ تعديل</button>
                      {ii>0 && <button onClick={()=>save('delete_issue',{issue_id:issue.id})}
                        style={{padding:'3px 7px',background:'#e74c3c',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',fontSize:'11px'}}>حذف</button>}
                    </div>
                  </div>
                  {issue.slot_partners.map(sp => (
                    <div key={sp.id} style={{display:'flex',alignItems:'center',gap:'8px',marginBottom:'4px',fontSize:'12px'}}>
                      <span style={{flex:1,color:'#333'}}>{sp.partner_name}</span>
                      <span style={{color:'#1e3a5f',fontWeight:'bold'}}>نصيب: {sp.share}</span>
                    </div>
                  ))}
                </div>
              ))}

              {newIssueSlot===slot.id ? (
                <div style={{background:'#e8f5e9',padding:'12px',borderRadius:'8px',border:'1px solid #27ae60'}}>
                  <h5 style={{margin:'0 0 10px',color:'#1e3a5f',fontSize:'13px'}}>إضافة إصدار جديد</h5>
                  <div style={{display:'flex',gap:'10px',marginBottom:'10px',flexWrap:'wrap'}}>
                    <div><label style={{display:'block',fontSize:'11px',fontWeight:'bold',marginBottom:'3px'}}>من تاريخ</label>
                      <input type="date" value={newIssueForm.from_date} onChange={e=>setNewIssueForm({...newIssueForm,from_date:e.target.value})}
                        style={{padding:'6px',border:'1px solid #ddd',borderRadius:'5px',fontSize:'12px'}}/></div>
                    <div><label style={{display:'block',fontSize:'11px',fontWeight:'bold',marginBottom:'3px'}}>اسم الإصدار</label>
                      <input value={newIssueForm.name} onChange={e=>setNewIssueForm({...newIssueForm,name:e.target.value})}
                        placeholder="مثال: بعد البيع" style={{padding:'6px',border:'1px solid #ddd',borderRadius:'5px',fontSize:'12px',width:'150px'}}/></div>
                  </div>
                  {newIssueForm.slot_partners.map((sp,si) => (
                    <div key={si} style={{display:'flex',gap:'8px',marginBottom:'8px',alignItems:'center'}}>
                      <select value={sp.partner_id} onChange={e=>{const n=[...newIssueForm.slot_partners];n[si]={...n[si],partner_id:e.target.value};setNewIssueForm({...newIssueForm,slot_partners:n});}}
                        style={{flex:1,padding:'6px',border:'1px solid #ddd',borderRadius:'5px',fontSize:'12px'}}>
                        <option value=''>اختر الشريك</option>
                        {partners.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
                      </select>
                      <div><label style={{display:'block',fontSize:'10px',marginBottom:'2px'}}>النصيب</label>
                        <input type="number" step="0.01" value={sp.share} onChange={e=>{const n=[...newIssueForm.slot_partners];n[si]={...n[si],share:e.target.value};setNewIssueForm({...newIssueForm,slot_partners:n});}}
                          style={{padding:'6px',border:'1px solid #ddd',borderRadius:'5px',fontSize:'12px',width:'150px'}}/></div>
                      {si>0 && <button onClick={()=>setNewIssueForm({...newIssueForm,slot_partners:newIssueForm.slot_partners.filter((_,j)=>j!==si)})}
                        style={{padding:'4px 7px',background:'#e74c3c',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',fontSize:'11px'}}>X</button>}
                    </div>
                  ))}
                  <div style={{display:'flex',gap:'8px',marginTop:'8px'}}>
                    <button onClick={()=>setNewIssueForm({...newIssueForm,slot_partners:[...newIssueForm.slot_partners,{partner_id:'',share:1}]})}
                      style={{padding:'5px 10px',background:'#3498db',color:'white',border:'none',borderRadius:'5px',cursor:'pointer',fontSize:'11px'}}>+ شريك آخر</button>
                    <button onClick={()=>{save('add_issue',{slot_id:slot.id,...newIssueForm});setNewIssueSlot(null);setNewIssueForm({from_date:'',name:'',slot_partners:[{partner_id:'',share:1}]});}}
                      style={{padding:'5px 12px',background:'#27ae60',color:'white',border:'none',borderRadius:'5px',cursor:'pointer',fontSize:'11px'}}>حفظ الإصدار</button>
                    <button onClick={()=>setNewIssueSlot(null)}
                      style={{padding:'5px 10px',background:'#e74c3c',color:'white',border:'none',borderRadius:'5px',cursor:'pointer',fontSize:'11px'}}>إلغاء</button>
                  </div>
                </div>
              ) : (
                <button onClick={()=>{setNewIssueSlot(slot.id);setNewIssueForm({from_date:'',name:'',slot_partners:[{partner_id:'',share:1}]});}}
                  style={{padding:'6px 14px',background:'#e67e22',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'12px',marginTop:'5px'}}>
                  + إضافة إصدار جديد (بيع/هبة/إرث)
                </button>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default Slots;
